<template>
  <div>
    <!-- Main Left Nav Menu -->
    <v-navigation-drawer v-model="leftNavDrawer" fixed clipped app>
      <v-list v-for="itemList in leftNavDrawerItems" :key="itemList.key">
        <v-list-tile v-for="item in itemList.items" :key="item.title" :to="{ path: item.path }">
          <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
          <v-list-tile-content><v-list-tile-title>{{ item.title }}</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        <v-divider/>
      </v-list>
      <v-list-tile @click.stop="leftNavDrawerHelp = !leftNavDrawerHelp">
        <v-list-tile-action><v-icon>help_outline</v-icon></v-list-tile-action>
        <v-list-tile-content><v-list-tile-title>Help</v-list-tile-title></v-list-tile-content>
      </v-list-tile>
    </v-navigation-drawer>

    <!-- Popover Help -->
    <v-navigation-drawer v-model="leftNavDrawerHelp" temporary fixed>
      <v-container>
        <h4>Help</h4>
        <p>Using the left navigation you can access different parts of the app.</p>
        <v-layout align-center justify-center style="position: absolute;bottom:10px;margin-right: 24px;">
            <v-flex xs10 sm8 md8>
              <img src="@/assets/Logo_Full_Green_Trans.png" style="width:100%;"/>
            </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'LeftNavigation',
  props: {
    leftNavDrawer: {
      type: Boolean,
      default: true
    },
    leftNavDrawerItems: {
      type: Array,
      default: function () {
        return [ { title: 'Home', icon: 'home', path: '/' } ]
      }
    },
    leftNavDrawerHelp: {
      type: Boolean,
      default: false
    }

  }
}
</script>
